import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CalcUtil from './ExamScoreUtil';

class ScoreCalculation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      canCalculateScore: false,
      scoreCalculated: false,
      score: 0,
      errorCode: 0,
      requireMoreScore: true,
    };
  }

  resetScore() {
    this.setState({
      canCalculateScore: false,
      scoreCalculated: false,
      score: 0,
      errorCode: 0,
      requireMoreScore: true,
    });
  }

  calculateScore(props) {
    if (!props.rules || props.rules.length === 0) {
      this.resetScore();
      return;
    }
    const canCalculateScore = CalcUtil.canCalculateScore(props.rules);
    if (canCalculateScore) {
      const result = CalcUtil.calculate(props.rules, props.myScores, props.additionalRules);
      // console.log('calculation result', JSON.stringify(result, null, 2));
      if (result.code !== CalcUtil.ERROR_CODE.DATA_NOT_READY) {
        const errorCode = result.code;

        const requireScore = errorCode === CalcUtil.ERROR_CODE.REQUIRE_SCORES;

        this.setState(prev => ({
          ...prev,
          score: result.sum,
          scoreCalculated: true,
          requireMoreScore: requireScore,
          errorCode,
          canCalculateScore,
        }));
      }
    } else {
      this.setState({
        canCalculateScore,
      });
    }
  }

  componentDidMount() {
    if (!this.props.myScoreLoading && this.props.enableScoreCalc) this.calculateScore(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.myScoreLoading && nextProps.enableScoreCalc) this.calculateScore(nextProps);
  }

  render() {
    if (this.props.render) {
      return this.props.render({
        score: this.state.score,
        canCalculateScore: this.props.enableScoreCalc && this.state.canCalculateScore,
        scoreCalculated: this.state.scoreCalculated,
        requireMoreScore: this.state.requireMoreScore,
        errorMessage: CalcUtil.ERROR_CODE_TEXT[this.state.errorCode],
      });
    } else if (this.props.disableRender) return this.props.disableRender();
    return null;
  }
}

ScoreCalculation.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      exams: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
      ).isRequired,
      rule: PropTypes.string.isRequired,
      minScoreFix: PropTypes.number,
      minScorePercent: PropTypes.number,
      weightPercent: PropTypes.number,
      multiplier: PropTypes.number,
    })
  ),
  additionalRules: PropTypes.shape({
    multiplier: PropTypes.number,
  }),
  myScores: PropTypes.arrayOf(
    PropTypes.shape({
      examId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      examScore: PropTypes.number,
    })
  ),
  render: PropTypes.func,
  enableScoreCalc: PropTypes.bool,
};

ScoreCalculation.defaultProps = {
  rules: [],
  enableScoreCalc: false,
};

export default ScoreCalculation;
